import React from 'react';
import { Toast } from 'zarm';

const StaticToast = {
  default: (children?: any, stayTime?: number, mask?: any, afterClose?: any) => {
    Toast.show(children);
  },
  success: (text?: string, stayTime?: number) => {
    StaticToast.default(<div className="custom">
      {/* <Icon className="custom-icon" type="right-round-fill" /> */}
      <div className="custom-text">
        {text}
      </div>
    </div>, stayTime || 2000);
  },
  warning: (text?: string, stayTime?: number) => {
    StaticToast.default(<div className="custom">
      {/* <Icon className="custom-icon" type="warning-round-fill" /> */}
      <div className="custom-text">
        {text}
      </div>
    </div>, stayTime || 2000);
  },
  error: (text?: string, stayTime?: number) => {
    StaticToast.default(<div className="custom">
      {/* <Icon className="custom-icon" type="wrong-round-fill" /> */}
      <div className="custom-text">
        {text}
      </div>
    </div>, stayTime || 2000);
  },
};

export default StaticToast;
